import React from "react";
import { Dialog, DialogTitle, DialogContent } from "@mui/material";

const ImagePreviewDialog = ({
  open,
  onClose,
  selectedImage,
  proofSelected,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      style={{ width: "100%" }}
    >
      <DialogTitle>File Preview</DialogTitle>
      <DialogContent>
        {selectedImage ? (
          <img
            src={selectedImage}
            alt="Preview"
            style={{ width: "100%", maxHeight: "400px" }}
          />
        ) : (
          <img
            src={proofSelected}
            alt="Proof Preview"
            style={{ width: "100%", maxHeight: "400px" }}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ImagePreviewDialog;
